import * as net from 'util/Net';

import {RESTAnalyticsVisualization} from './RESTAnalyticsVisualizationTypes';

export type UpdateAnalyticsVisualizationData = Omit<RESTAnalyticsVisualization, 'id'>;

export function updateAnalyticsVisualization(
  analyticsVisualizationId: string,
  data: UpdateAnalyticsVisualizationData
): Promise<RESTAnalyticsVisualization> {
  return net.patchJSONPromise({
    url: `/1/api/analytics-visualizations/${analyticsVisualizationId}`,
    data,
  });
}
